@let breadcrumbs = list$ | async;
@if (breadcrumbs) {
    <div
        *transloco="let t"
        class="bazis-container bazis-breadcrumbs"
    >
        @if (breadcrumbs.length > doNotDisplayLength()) {
            <div
                class="bazis-list bazis-list_h"
                itemscope
                itemtype="https://schema.org/BreadcrumbList"
                [class.bh-flex-wrap]="mqSrv.inIntervalBreakpoint('xs', 'lg')"
            >
                @for (breadcrumb of breadcrumbs; track $index; let i = $index) {
                    <div
                        class="bazis-item"
                        [class.bazis-only-icon]="breadcrumb.useOnlyIcon"
                        itemprop="itemListElement"
                        itemscope
                        itemtype="https://schema.org/ListItem"
                    >
                        @if (i !== 0) {
                            <bazis-icon
                                [icon]="separator()"
                                size="regular"
                            ></bazis-icon>
                        }

                        @if (!breadcrumb.name && breadcrumb.type === 'entityData') {
                            <!-- move to breadcrumbs item component if we will have more different types -->
                            <a
                                [routerLink]="breadcrumb.url"
                                itemprop="item"
                            >
                                @if (breadcrumb.icon) {
                                    <bazis-icon [icon]="breadcrumb.icon"></bazis-icon>
                                }

                                @if (!breadcrumb.useOnlyIcon) {
                                    <span itemprop="name">
                                        @if (
                                            breadcrumb.entity.entityType !==
                                            'organization.organization_info'
                                        ) {
                                            <!-- if breadcrumb with entity type is last in a chain, suppose that this entity will be asked in main component -->
                                            @let entity =
                                                breadcrumb.params[
                                                    breadcrumb.entity.idParamName || 'id'
                                                ]
                                                    | entity
                                                        : breadcrumb.entity.entityType
                                                        : false
                                                        : i === breadcrumbs.length - 1
                                                    | async;
                                            @if (entity) {
                                                {{
                                                    entity.$snapshot[
                                                        breadcrumb.entity.nameField || 'name'
                                                    ]
                                                }}
                                            }
                                        }

                                        @if (
                                            breadcrumb.entity.entityType ===
                                            'organization.organization_info'
                                        ) {
                                            @let entity =
                                                breadcrumb.params[
                                                    breadcrumb.entity.idParamName || 'id'
                                                ]
                                                    | organization
                                                    | async;
                                            {{
                                                entity.$snapshot[
                                                    breadcrumb.entity.nameField || 'name'
                                                ]
                                            }}
                                        }
                                    </span>
                                }
                            </a>
                        }

                        @if (breadcrumb.name) {
                            <a
                                [routerLink]="breadcrumb.url"
                                itemprop="item"
                            >
                                @if (breadcrumb.icon) {
                                    <bazis-icon [icon]="breadcrumb.icon"></bazis-icon>
                                }

                                @if (!breadcrumb.useOnlyIcon) {
                                    <span itemprop="name">
                                        {{ t(breadcrumb.name, breadcrumb.params) }}
                                    </span>
                                }
                            </a>
                        }
                        <meta
                            itemprop="position"
                            [content]="i + 1"
                        />
                    </div>
                }
            </div>
        }
    </div>
}
